import React from "react";
import { Link } from "react-router-dom";

import ProjectSpotlight from "./ProjectSpotlight";
import { portfolioSrc, portfolioSrcSet } from "../lib/images";

const Portfolio = ({ data }) => {
  const projects = Array.isArray(data?.projects) ? data.projects : [];

  const featured = projects.filter((p) => p.featured);
  const rest = projects.filter((p) => !p.featured);
  // Link-outs (no slug, no case study) sit below the grid as plain links.
  const cards = rest.filter((p) => p.slug);
  const linkOuts = rest.filter((p) => !p.slug);

  return (
    <section id="portfolio">
      <div className="row">
        <div className="twelve columns collapsed portfolio-header">
          <h1>Featured work</h1>
          <p className="portfolio-subtitle">
            Open a project for how it was built. More code on{" "}
            <a
              href="https://github.com/Tony04031234"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
            .
          </p>
        </div>
      </div>

      {featured.length > 0 ? (
        <div className="row">
          <div className="twelve columns">
            <div className="projects-spotlights">
              {featured.map((p, i) => (
                <ProjectSpotlight key={p.title} project={p} index={i} />
              ))}
            </div>
          </div>
        </div>
      ) : null}

      <div className="row">
        <div className="twelve columns">
          {projects.length === 0 ? (
            <p className="portfolio-empty">Projects will be listed here soon.</p>
          ) : (
            <>
              {cards.length > 0 ? (
                <>
                  {featured.length > 0 ? (
                    <h2 className="portfolio-subheading">Also built</h2>
                  ) : null}
                  <div className="projects-grid">
                    {cards.map((p) => {
                      const img = p.coverImage || p.image;
                      const imageUrl = portfolioSrc(img);

                      return (
                        <Link
                          key={p.title}
                          to={`/projects/${p.slug}`}
                          className="project-card-link"
                        >
                          <article className="project-card">
                            {imageUrl ? (
                              <div className="project-card-media">
                                <img
                                  src={imageUrl}
                                  srcSet={portfolioSrcSet(img)}
                                  sizes="(min-width: 1020px) 320px, (min-width: 767px) 45vw, 92vw"
                                  alt={`${p.title} cover`}
                                  loading="lazy"
                                  decoding="async"
                                />
                              </div>
                            ) : null}
                            <div className="project-card-body">
                              <div className="project-card-top">
                                <h3 className="project-card-title">{p.title}</h3>
                                {p.badge ? (
                                  <span className="project-card-badge">
                                    {p.badge}
                                  </span>
                                ) : null}
                              </div>
                              {p.category ? (
                                <p className="project-card-kicker">
                                  {p.category}
                                </p>
                              ) : null}
                              {p.cardSummary ? (
                                <p className="project-card-summary">
                                  {p.cardSummary}
                                </p>
                              ) : null}
                              {Array.isArray(p.stack) && p.stack.length > 0 ? (
                                <div className="project-card-tags">
                                  {p.stack.slice(0, 5).map((t) => (
                                    <span className="project-pill" key={t}>
                                      {t}
                                    </span>
                                  ))}
                                </div>
                              ) : null}
                              <div className="project-card-cta">
                                Read case study →
                              </div>
                            </div>
                          </article>
                        </Link>
                      );
                    })}
                  </div>
                </>
              ) : null}

              {linkOuts.length > 0 ? (
                <p className="portfolio-linkouts">
                  {linkOuts.map((p) => (
                    <a
                      key={p.title}
                      className="portfolio-linkout"
                      href={p.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {p.title} ↗
                    </a>
                  ))}
                </p>
              ) : null}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
